var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "alert alert-info", attrs: { role: "alert" } },
    [
      _c("span", {
        staticClass: "alert-icon",
        attrs: { "aria-hidden": "true" },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "alert-content" }, [
        _c(
          "a",
          {
            staticClass: "ob1-link-arrow ob1-link-dark ob1-link-small",
            attrs: { href: _vm.linkUrl },
          },
          [_vm._v(_vm._s(_vm.message))]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }